/**
 * Which imported ids actually enter the selection.
 *
 * The step imports every id the source list holds (`rawIds`), then optionally
 * drops the ones already present on the target licence. This is the single rule
 * behind both the import itself and the "Exclude inter-list duplicates" toggle,
 * so the two can never disagree.
 */
export function applyExclusion(
  rawIds: string[],
  duplicateIds: string[],
  exclude: boolean,
): string[] {
  if (!exclude || duplicateIds.length === 0) return rawIds;
  const dupSet = new Set(duplicateIds);
  return rawIds.filter((id) => !dupSet.has(id));
}
